import { useEffect } from "react";
import axios from "axios";

import { getToken } from "../Utils/helper";

const MsAuthRedirect = () => {
  useEffect(() => {
    const redirectCall = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const accessToken = getToken();
      const origin = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";

      if (!code) {
        console.error("No code found in URL parameters");
        return;
      }

      try {
        const response = await axios.get(`${origin}/api/firmsetting-page/ms_redirect_with_auth/`, {
          params: { code: code },
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken, // Optional Authorization header
          },
        });

        if (response.status === 200) {
          const caseId = response.data.data.case_id;
          const clientId = response.data.data.client_id;
          // Redirecting immediately after receiving the response
          if (clientId) localStorage.setItem("client_id", clientId);
          if (caseId) localStorage.setItem("case_id", caseId);
          window.location.href = "/bp-firmsetting";
        } else {
          console.error("Unexpected response status:", response.status);
        }
      } catch (error) {
        console.error("Error fetching the redirect URL:", error);
      }
    };

    // Call the redirect function as soon as component mounts
    redirectCall();
  }, []); // Empty dependency array ensures this runs only once on mount

  return null;
};

export default MsAuthRedirect;
